import { from } from 'rxjs'
import { mergeMap, map } from 'rxjs/operators'
import { afterAllTypes } from '../../../../lib/observables'
import * as actionTypes from '../../../constants/actionTypes'
import { ReduxAction } from '../../../reducers/reducerType'
import { UserServiceResponseInterface, Enum } from '@bt-react/store'
import roomAction from '../../../actions/room'
import { ParticipantInformationInterface } from '../../../reducers/docs/syncUi/types'
import { addEntry } from '../../../../lib/audit'

/** Format the user service response into the expected type of the doc */
function formatParticipantInformation (userData: UserServiceResponseInterface): ParticipantInformationInterface {

  const { externalIdV2, firstName, lastName, jobTitle, photoId, companyName } = userData

  if (externalIdV2 === null) addEntry('PresenterService', 'AccessModalDisplayed',
    `The user service has returned a null value for externalIdV2. Data returned: ${JSON.stringify(userData)}}`)

  return {
    BTID: externalIdV2,
    id: externalIdV2,
    firstName,
    lastName,
    jobTitle,
    photoId,
    companyName
  }

}

const addParticipantInformation$ = (actions$, state$, { setParticipantInformation }) => actions$.pipe(
  afterAllTypes(Enum.UserServiceType.FETCH_USER_DATA_SUCCESS, actionTypes.SET_UI_DOCUMENT),
  mergeMap((actions: ReduxAction[]) => {

    let uiDoc
    let userServiceResponse

    for (const { type, payload } of actions) {

      switch (type) {

        case Enum.UserServiceType.FETCH_USER_DATA_SUCCESS:
          userServiceResponse = payload
          break
        case actionTypes.SET_UI_DOCUMENT:
          uiDoc = payload
          break
        default:
          break

      }

    }

    const participantInformation: ParticipantInformationInterface = formatParticipantInformation(userServiceResponse)

    return from(setParticipantInformation(uiDoc, participantInformation))
      .pipe(
        map(entryAdded => {
          if (entryAdded) return roomAction.participantInformationAdded()

          addEntry('PresenterService', 'DocumentUpdated',  `Unable to store user service response from setParticipantInformation: Participant info: ${participantInformation}.`)
          return roomAction.participantInformationError()
        })
      )

  })
)

export default addParticipantInformation$
